module.exports = __webpack_public_path__ + "media/promo/advent/images/logom-5-522a132139c2a524ea3657ade3d96c0c.png";